/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSouscriptionActivePolicyMutation from '../graphql/mutations/SaveSouscriptionActivePolicyMutation.js';

export const useSaveSouscriptionActivePolicyMutation = () => {
  return useCommitMutation(SaveSouscriptionActivePolicyMutation, {
    dataProp: 'saveSouscriptionActivePolicy_M_souscription_active_policy'
  });
};

export default useSaveSouscriptionActivePolicyMutation;
